import React, { useState, useEffect } from 'react';
import { TextField, ImageField, VideoField, GifField, InputField, RatingField, ButtonField } from '../../components/FieldComponents';
import Response from '../../components/Response';
import Theme from '../../components/Theme';
import styles from './FormBuilder.module.css';
import close1 from '../../images/close.svg';
import text11 from '../../images/text11.svg';
import image11 from '../../images/image11.svg';
import video11 from '../../images/video11.svg';
import gif11 from '../../images/gif11.svg';
import textinput11 from '../../images/textinput11.svg';
import number11 from '../../images/number11.svg';
import email11 from '../../images/email11.svg';
import phone11 from '../../images/phone11.svg';
import date11 from '../../images/date11.svg';
import rating11 from '../../images/rating11.svg';
import button11 from '../../images/button11.svg';
import builderdelete from '../../images/builderdelete.svg';
import { useNavigate } from "react-router-dom";

import { useParams } from 'react-router-dom';
import axios from 'axios';

const FormBuilder = () => {

  const { folderName, formid11 } = useParams();

  const [fields, setFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [formName, setFormName] = useState('');
  const [reid, setReid] = useState(formid11);
  const [shareLink, setShareLink] = useState('');
  const [token] = useState(!!localStorage.getItem("token"));
  const [showResponses, setShowResponses] = useState(false);
  const [showTheme, setShowTheme] = useState(false);
  const [showFormBuilder, setShowFormBuilder] = useState(true);

  
  const handleclickResponse = () => {
    setShowResponses(true);
    setShowTheme(false);
    setShowFormBuilder(false);
  };

  const handleclickTheme = () => {
    setShowResponses(false);
    setShowTheme(true);
    setShowFormBuilder(false);
  };

  const handleclickFlow = () => {
    setShowResponses(false);
    setShowTheme(false);
    setShowFormBuilder(true);
  };

  const navigate = useNavigate();


  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
  }, [token, navigate]);

  const addField = (type) => {
    setFields([...fields, { id: fields.length + 1, type }]);
  };

  const handleChange = (id, value) => {
    setFormData({ ...formData, [id]: value });
  };

  const handleFormNameChange = (e) => {
    setFormName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = fields.every(field => {
      if (["Text", "Image", "Video", "Gif"].includes(field.type)) {
        return formData[field.id];
      }
      return true;
    });

    if(isValid){
      
      try {
        

        const response = await axios.post('https://formbot-a0ti.onrender.com/addform', {
          folderName: folderName,
          formname: formName,
          fields: fields.map(field => ({
            id: field.id,
            type: field.type,
            value: formData[field.id] || ''
          })),
        

        });
        
        setShareLink(`${window.location.origin}/formbots/${response.data._id}`);
        //console.log(response.data._id);
        setReid(response.data._id);
        
      } catch (error) {
        console.error('Error saving form:', error);
      }
    } else {
      alert("Please fill all required fields");


    }
  };
  const handleShare = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      alert('Link copied to clipboard');
    });
  }
  return (
    <>

      {token && (
        <>
      
        <div className={styles.formBuilder}>
          <form className={styles.formPreview} onSubmit={handleSubmit}>
            <div className={styles.header}>
              <input
                type="text"
                placeholder="Enter Form Name"
                value={formName}
                onChange={handleFormNameChange}
                required
              />
              <button className={ showFormBuilder ? styles.flow8 : styles.flow} type="button" onClick={handleclickFlow}>
                Flow
              </button>
              <button className={ showTheme ? styles.theme8 : styles.theme } type="button" onClick={handleclickTheme}>
                Theme
              </button>
              <button className={showResponses ? styles.response8 : styles.response} type="button" onClick={handleclickResponse}>
                Response
              </button>
              {shareLink && (
                <button className={styles.share} onClick={handleShare} type="button">
                  Share
                </button>
              )}
              <button className={styles.save} type="submit">
                Save
              </button>
              <img src={close1} alt="" onClick={() => navigate('/dashboard')} />
            </div>

            {showResponses && <Response reid={reid}/>}
      {showTheme && <Theme formid={reid} />}
      
      {showFormBuilder && (
        <>
       {formid11==='newform' ? (
        <>
        <div className={styles.fieldOptions}>
          <p className={styles.bubbles}>Bubbles</p>
          <button className={styles.text11} type="button" onClick={() => addField("Text")}><img src={text11} alt=''/>Text</button>
          <button className={styles.image11} type="button" onClick={() => addField("Image")}><img src={image11} alt=''/>Image</button>
          <button className={styles.video11} type="button" onClick={() => addField("Video")}><img src={video11} alt=''/>Video</button>
          <button className={styles.gif11} type="button" onClick={() => addField("Gif")}><img src={gif11} alt=''/>GIF</button>
          <p className={styles.inpu}>Inputs</p>
          <button className={styles.textinput11} type="button" onClick={() => addField("TextInput")}><img src={textinput11} alt=''/>Text Input</button>
          <button className={styles.number11} type="button" onClick={() => addField("Number")}><img src={number11} alt=''/>Number</button>
          <button className={styles.email11} type="button" onClick={() => addField("Email")}><img src={email11} alt=''/>Email</button>
          <button className={styles.phone11} type="button" onClick={() => addField("Phone")}><img src={phone11} alt=''/>Phone</button>
          <button className={styles.date11} type="button" onClick={() => addField("Date")}><img src={date11} alt=''/>Date</button>
          <button className={styles.rating11} type="button" onClick={() => addField("Rating")}><img src={rating11} alt=''/>Rating</button>
          <button className={styles.button11} type="button" onClick={() => addField("Button")}><img src={button11} alt=''/>Button</button>
        </div>
        <div className={styles.start}>
          <p>Start</p>
        </div>
        {fields.map(field => {
          switch (field.type) {
            case "Text":
              return (
                <div className={styles.fieldContainer} key={field.id}>
                  <img src={builderdelete} className={styles.builderdelete} alt='' />
                  <TextField id={field.id} handleChange={handleChange} />
                 
                </div>
              );
            case "Image":
              return (
                <div className={styles.fieldContainer} key={field.id}>
                  <img src={builderdelete} className={styles.builderdelete} alt='' />
                  <ImageField id={field.id} handleChange={handleChange} />
                </div>
              );
            case "Video":
              return (
                <div className={styles.fieldContainer} key={field.id}>
                  <VideoField id={field.id} handleChange={handleChange} />
                </div>
              );
            case "Gif":
              return (
                <div className={styles.fieldContainer} key={field.id}>
                  <GifField id={field.id} handleChange={handleChange} />
                </div>
              );
            case "Rating":
              return (
                <div className={styles.fieldContainer} key={field.id}>
                  <RatingField id={field.id} handleChange={handleChange} />
                </div>
              );
            case "Button":
              return (
                <div className={styles.fieldContainer} key={field.id}>
                  <ButtonField id={field.id} handleChange={handleChange} />
                </div>
              );
            default:
              return (
                <div className={styles.fieldContainer} key={field.id}>
                  <InputField id={field.id} type={field.type.toLowerCase()} handleChange={handleChange} />
                </div>
              );
          }
        })}
        </>
        ):(
          <p className={styles.nulldata8}>Form is already created click on Response button to view more details</p>
       
         )} 
          </>
        )}
        
         
      </form>
        </div>
     
    </>
  )}
</>
);
};
export default FormBuilder;
